import { render, staticRenderFns } from "./BarY.vue?vue&type=template&id=0b6ff293&"
import script from "./BarY.vue?vue&type=script&lang=js&"
export * from "./BarY.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports